<template>
  <div>
    <div class="search-bar-margin-bottom-cla">
      <el-form :inline="true">
        <el-form-item :label="this.$t('advice.createTime')">
          <el-date-picker
            class="pickData_cla"
            v-model="value2"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="-"
            :start-placeholder="this.$t('advice.beginTime')"
            :end-placeholder="this.$t('advice.endTime')"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="this.$t('advice.replayStatus')">
          <el-select clearable v-model="flag" placeholder>
            <el-option :label="this.$t('advice.replied')" value="1"></el-option>
            <el-option :label="this.$t('advice.noReply')" value="0"></el-option>
            <el-option :label="this.$t('advice.all')" value></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">{{
            $t('common.search')
          }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="black_panel_cla">
      <div class="header-button-bar">
        <zk-tool-bar @addAdvice="addAdvice"></zk-tool-bar>
      </div>
      <el-table
        @row-dblclick="dblclick"
        :stripe="true"
        :data="data"
        :expand-row-keys="expands"
        :row-key="getRowKeys"
        style="width: 100%"
      >
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="advice" :label="this.$t('advice.advice')">
          <template slot-scope="scope">
            <div
              style="
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              "
            >
              {{ scope.row.advice }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="reply" :label="this.$t('advice.reply')">
          <template slot-scope="scope">
            <div
              style="
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              "
            >
              {{ isEmpty(scope.row.reply) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="createdBy"
          :label="this.$t('advice.createdBy')"
          v-if="hasPermission('c404a610190c4a96930806a48c30e880')"
        ></el-table-column>
        <el-table-column
          prop="createdDate"
          :label="this.$t('advice.createdDate')"
        >
          <template slot-scope="scope">
            {{ scope.row.createdDate | dataFormat }}
          </template>
        </el-table-column>
        <el-table-column
          prop="replyBy"
          :label="this.$t('advice.replyBy')"
          v-if="hasPermission('c404a610190c4a96930806a48c30e880')"
        >
          <template slot-scope="scope">
            {{ isEmpty(scope.row.replyBy) }}
          </template>
        </el-table-column>

        <el-table-column
          prop="replyDate"
          :label="this.$t('advice.replyDate')"
          v-if="hasPermission('c404a610190c4a96930806a48c30e880')"
        >
          <template slot-scope="scope">
            <span
              v-if="
                scope.row.replyDate !== undefined ||
                  scope.row.replyDate !== '' ||
                  scope.row.replyDate !== null
              "
              >{{ scope.row.replyDate | dataFormat }}</span
            >
            <span v-else> {{ isEmpty(scope.row.replyDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" :label="this.$t('advice.status')">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1" style="color: @themeColor">
              {{ $t('advice.replied') }}
            </span>
            <span v-else>{{ $t('advice.noReply') }}</span>
          </template>
        </el-table-column>

        <el-table-column
          :label="this.$t('common.action')"
          width="240px"
          align="center"
        >
          <template slot-scope="scope">
            <span
              @click.stop="toggleRowExpansion(scope.row)"
              class="btn-text-cla"
            >
              {{ $t('common.details') }}</span
            >
            <span
              @click.stop="replay(scope.row)"
              v-if="hasPermission('c404a610190c4a96930806a48c30e880')"
              class="btn-text-cla"
              >{{ $t('advice.replayBtn') }}</span
            >

            <span
              @click.stop="delte(scope.row)"
              v-if="
                hasPermission('c404a610190c4a96930806a48c30e880') &&
                  hasPermission('3e4219adcc134ce4ba9ea5ecf11c3e3e')
              "
              class="btn-text-cla"
              >{{ $t('common.delete') }}</span
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-margin-top">
        <el-pagination
          background
          @size-change="pageSizeChange(arguments[0], commQuery)"
          @current-change="curPageChange(arguments[0], commQuery)"
          :current-page="pager.curPage"
          :page-size="pager.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pager.total"
        ></el-pagination>
      </div>
    </div>

    <el-drawer :visible.sync="drawer" :with-header="false">
      <div class="advice-log-detail-cla" v-if="detailRow">
        <div class="item-detail-cla">
          <div class="logItem_label">{{ $t('advice.createTime') }}:</div>
          <div class="logItem_value">
            {{ detailRow.createdDate | dataFormat }}
          </div>
        </div>

        <div class="item-detail-cla">
          <div class="logItem_label">{{ $t('advice.advice') }}:</div>
          <div class="logItem_value">{{ detailRow.advice }}</div>
        </div>

        <div class="item-detail-cla" v-if="detailRow.replyDate">
          <div class="logItem_label">{{ $t('advice.replyDate') }}:</div>
          <div class="logItem_value">
            {{ detailRow.replyDate | dataFormat }}
          </div>
        </div>

        <div class="item-detail-cla" v-if="detailRow.reply">
          <div class="logItem_label">{{ $t('advice.reply') }}:</div>
          <div class="logItem_value">{{ detailRow.reply }}</div>
        </div>
      </div>
    </el-drawer>

    <!-- 添加 -->
    <el-dialog
      :title="this.$t('advice.addAdvice')"
      :visible.sync="addA"
      :before-close="onCancel"
      width="45%"
    >
      <el-form ref="form" :model="form" :rules="addRule" label-width="100px">
        <el-form-item :label="this.$t('advice.adviceContent')" prop="advice">
          <el-row>
            <el-col :span="20">
              <el-input
                v-model="form.advice"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 6 }"
                maxlength="200"
                @input="addAdviceLength"
              ></el-input>
            </el-col>
            <el-col :span="4" align="center">
              <span v-if="advLength === 200" style="color: red"
                >{{ advLength }}/200</span
              >
              <span v-else>{{ advLength }}/200</span>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCancel">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submitAdd">
          {{ $t('common.confirm') }}
        </el-button>
      </span>
    </el-dialog>
    <!-- 回复 -->
    <el-dialog
      :title="this.$t('advice.adviceReplay')"
      :visible.sync="advReply"
      :before-close="onCancelReply"
      width="40%"
    >
      <el-form
        ref="replyForm"
        :model="replays"
        :rules="replayRule"
        label-width="110px"
      >
        <el-form-item :label="this.$t('advice.advContent')">
          <label>{{ adv }}</label>
        </el-form-item>
        <el-form-item
          :label="this.$t('advice.replayContent')"
          prop="replyContent"
        >
          <el-input
            v-model="replays.replyContent"
            type="textarea"
            @input="getRelyContentLength"
            :autosize="{ minRows: 4, maxRows: 10 }"
            maxlength="100"
            :placeholder="this.$t('advice.reply')"
          ></el-input>
          <div style="text-align: right">
            <span v-if="replyLength === 100" style="color: red"
              >{{ replyLength }}/100</span
            >
            <span v-else>{{ replyLength }}/100</span>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCancelReply">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submitReply">
          {{ $t('common.confirm') }}
        </el-button>
      </span>
    </el-dialog>
    <!-- 删除 -->
    <el-dialog
      :title="this.$t('common.warningNotice')"
      :visible.sync="deleteDailog"
      width="30%"
    >
      <span>{{ $t('advice.deleteSure') }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDailog = false">
          {{ $t('common.cancel') }}
        </el-button>
        <el-button type="primary" @click="deleteAdvice">
          {{ $t('common.yes') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as advService from '../../../services/adviceApi'
export default {
  data() {
    let adviceRule = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('announcement.inputContent')))
      } else {
        callback()
      }
    }
    let replayRules = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('announcement.inputContent')))
      } else {
        callback()
      }
    }
    return {
      deleteDailog: false,
      replyLength: 0,
      drawer: false,
      detailRow: {},
      advLength: 0,
      expands: [],
      data: [],
      params: {
        beginTime: '',
        endTime: '',
        status: ''
      },
      addA: false,
      advReply: false,
      form: {
        advice: ''
      },
      replays: {
        replyContent: ''
      },
      adv: '',
      currentRow: [],
      flag: '',
      value2: [],
      addRule: {
        advice: [
          {
            required: true,
            validator: adviceRule,
            trigger: ['blur', 'change']
          }
        ]
      },
      replayRule: {
        replyContent: [
          {
            required: true,
            validator: replayRules,
            trigger: ['blur', 'change']
          }
        ]
      },
      id: ''
    }
  },
  methods: {
    delte(row) {
      this.deleteDailog = true
      this.id = row.id
    },
    deleteAdvice() {
      advService
        .romove({
          id: this.id
        })
        .then(data => {})
        .catch(e => {
          this.errorMessage()
        })
        .finally(e => {
          this.deleteDailog = false
          this.query()
        })
    },
    getRelyContentLength() {
      this.replyLength = this.replays.replyContent.length
    },
    addAdviceLength() {
      this.advLength = this.form.advice.length
    },
    search() {
      this.query()
    },

    getRowKeys(row) {
      return row.id
    },
    dblclick(row) {
      this.toggleRowExpansion(row)
    },

    toggleRowExpansion(row) {
      this.drawer = true
      this.detailRow = row
    },
    replay(row) {
      this.adv = row.advice
      this.currentRow = row
      this.advReply = true
      if (row.reply !== '') {
        this.replays.replyContent = row.reply
        this.replyLength = row.reply.length
      } else {
        this.replays.replyContent = ''
      }
    },
    addAdvice() {
      this.addA = true
    },
    query() {
      this.pager.curPage = 1
      this.commQuery()
    },
    commQuery() {
      this.params.status = this.flag
      if (this.value2 && this.value2.length !== 0) {
        this.params.beginTime = Date.parse(this.value2[0])
        this.params.endTime = Date.parse(this.value2[1])
      } else {
        this.params.beginTime = ''
        this.params.endTime = ''
      }
      advService
        .list({
          pager: this.pager,
          params: this.params
        })
        .then(data => {
          if (data.code === '00000000') {
            this.data = data.payload.results.results || data.payload.results
            this.pager.pageSize =
              data.payload.pageSize || data.payload.results.pageSize
            this.pager.curPage =
              data.payload.curPage || data.payload.results.curPage
            this.pager.total =
              data.payload.totalRecords || data.payload.results.totalRecords
          } else {
            this.$message.error(data.$message)
          }
        })
    },
    submitReply() {
      this.$refs.replyForm.validate(valid => {
        if (valid) {
          advService
            .replay({
              id: this.currentRow.id,
              reply: this.replays.replyContent,
              status: 1
            })
            .then(data => {
              if (data.code === '00000000') {
                this.query()
              }
            })
            .catch(e => {
              this.errorMessage()
            })
            .finally(e => {
              this.onCancelReply()
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitAdd() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let _self = this
          advService
            .add({
              active: _self.form.advice
            })
            .then(data => {
              if (data.code === '00000000') {
                this.query()
              }
            })
            .catch(e => {
              this.errorMessage()
            })
            .finally(e => {
              this.onCancel()
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onCancel() {
      this.$refs.form.resetFields()
      this.addA = false
      this.advLength = 0
    },
    onCancelReply() {
      this.$refs.replyForm.resetFields()
      this.advReply = false
      this.replyLength = 0
    }
  },
  mounted() {
    this.query()
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-table__expand-icon > .el-icon {
  display: none;
}
.arrow_icon {
  position: absolute;
  top: -20px;
  right: 9.5%;
  width: 0px;
  height: 0px;
  border: 20px solid;
  border-color: transparent transparent #a99e9e transparent;
}
.arrow_icon2 {
  position: absolute;
  top: -18px;
  z-index: 1000;
  right: 9.5%;
  width: 0px;
  height: 0px;
  border: 20px solid;
  border-color: transparent transparent #eceaea transparent;
}
.logDeatil_cla {
  position: relative;
  background: #eceaea;
  border-radius: 20px;
  border: 1px solid #a99e9e;
  width: 98%;
  margin: 20px auto;
}

.advice-log-detail-cla {
  padding: 15px;
  .item-detail-cla {
    // lable{
    //   padding-right: 20px;
    // }
    padding: 15px 0px;
    border-bottom: 1px solid #dedcda;
    //logItem_label
    .logItem_value {
      font-size: 14px;
    }
  }
}

// .item-detail-cla {
//   line-height: 1.5;
//   .logItem_label {
//     float: left;
//     padding-right: 10px;
//     font-size: 12px;
//     color: #333333;
//     text-align: right;
//     width: 120px;
//   }
//   .logItem_value {
//     display: flow-root;
//     word-break: break-word;
//     font-size: 12px;
//     color: #999999;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/modules/zkCdpPage/message/adviceList.vue